var _path, _circle, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgIconConsult = function SvgIconConsult(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 48 48",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4DC6E3",
    stroke: "#4DC6E3",
    strokeWidth: 3,
    d: "m43.5 23.982-.465 19.053-19.053.465C13.221 43.49 4.5 34.764 4.5 24 4.5 13.23 13.23 4.5 24 4.5c10.764 0 19.49 8.72 19.5 19.482Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 18,
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#4DC6E3",
    d: "M18.753 29.604a1.46 1.46 0 0 1-1.087 1.683c-.917.23-2.393.185-4.113-1.425-.873-.818-1.196-1.737-1.146-2.544.115-1.88 2.267-3.153 4.28-1.113 1.436 1.449 1.93 2.605 2.066 3.399"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#69E4FF",
    d: "M20.018 19.39c.517 1.06.765 2.264.875 3.36a2 2 0 0 1-.52 1.574c-.657.712-1.795.938-2.696.27a9.56 9.56 0 0 1-2.662-3.013c-.438-.782-.575-1.543-.499-2.216.287-2.537 3.636-3.8 5.502.025"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#4DC6E3",
    d: "M26.611 15.933c.594 1.688.464 3.533.226 4.854-.061.338-.224.62-.446.83a1.5 1.5 0 0 1-1.877.163c-.994-.658-2.203-1.815-3.117-3.825-.319-.704-.422-1.352-.362-1.923.272-2.767 4.308-3.694 5.576-.1Zm7.168 3.712a6 6 0 0 1-.701 2.54 7 7 0 0 1-.891 1.297c-.71.825-2.05.597-2.414-.43-.405-1.137-.783-2.686-.658-4.288q.003-.048.01-.1c.335-3.076 4.858-3.413 4.654.98Zm.155 9.043c.058.54-.078 1.1-.524 1.607-.58.657-1.689 1.229-3.594 1.571-4.203.75-5.81 5.136-8.502 3.434-1.13-.717-1.149-1.92-.878-2.96.279-1.08.876-1.986.876-1.986s.031-.043.078-.126c.186-.314.631-1.202.678-2.458q.009-.227.045-.444c.39-2.405 3.116-3.98 5.758-1.694 1.603 1.384 5.721-.062 6.06 3.057z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIconConsult);
export default ForwardRef;